import { Image } from '@/components'
import { URL_ICON } from '@/constants/ui'
import ProductSlide from '@/features/home/components/product-slide'
import { Divider, Stack, Typography } from '@mui/material'
import React from 'react'

type Props = {
  dataDetail?: Product
}

export default function SlideProductRelated({ dataDetail }: Props) {
  if (!dataDetail?.related_products || dataDetail.related_products.length === 0) {
    return null
  }
  return (
    <Stack spacing={2}>
      <Divider />
      <Stack spacing={1}>
        <Stack direction={'row'} alignItems={'center'} spacing={1}>
          <Image
            src={URL_ICON + 'ic-3circle.svg'}
            style={{
              width: '16px',
              height: '16px',
            }}
          />
          <Typography component={'span'}>Gợi ý phối đồ với</Typography>
        </Stack>
        <ProductSlide
          classSwiper="swiper-sale-product"
          products={dataDetail?.related_products}
          slidesPc={4}
          slidesTablet={3}
          slidesMobile={1.5}
          isSale={false}
        />
      </Stack>
    </Stack>
  )
}
